module.exports = __webpack_public_path__ + "img/lizegang.9e9a17cd.jpg";